import React from 'react';
import { Select } from '@pattern-library/select';
import PropTypes from 'prop-types';
const propTypes = {
  errorMessage: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
  status: PropTypes.oneOf(['disabled']),
  useNextUI: PropTypes.bool,
  value: PropTypes.node.isRequired
};
function SelectCell(_ref) {
  let {
    errorMessage,
    id,
    label,
    onChange,
    options,
    status,
    useNextUI = true,
    value
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "asc-table-component-editable-cell"
  }, /*#__PURE__*/React.createElement(Select, {
    options: options,
    id: id,
    showEmptyOption: true,
    value: value,
    onChange: onChange,
    label: label,
    hideLabel: true,
    reactSelectProps: {
      disablekeydownhandler: 'true',
      menuPosition: 'fixed'
    },
    errorMessage: errorMessage,
    isDisabled: status === 'disabled',
    useNextUI: useNextUI ? useNextUI : false
  }));
}
SelectCell.propTypes = propTypes;
export default SelectCell;